const lightTheme = {
  background: {
    primary: '#ECECEC',
    secondary: '#FFFFFF',
    tertiary: '#f0dddd85',
    highlight: '#eea2a2',
  },
  font: {
    primary: '#333333',
    secondary: '#666666',
    tertiary: '#999999',
    highlight: '#eea2a2',
  },
};

export default lightTheme;
